module.exports = __webpack_public_path__ + "static/media/v7.4faf222d.mp4";